import React, { useState } from "react";
import { Redirect } from "react-router-dom";

import TabbedContent, { IActivatedCallBack } from "../TabbedContent";
import ScreenLayout from "../ScreenLayout";
import ActiveRuns from "./ActiveRuns";
import CompletedRuns from "./CompletedRuns";
import PigAlertsPage from "./PigAlertsPage";
import PigHistoryPage from "./PigHistoryPage";
import { useAuth } from "../../contexts/AuthProvider";
// import { OrganizationProvider } from "../../contexts/OrganizationProvider";
// import { LiveStatusProvider } from "../../contexts/LiveStatusProvider";

import MobilePageTitle from "../MobilePageTitle";
import PigHeaderProvider, { usePigHeaderContext } from "./PigHeaderProvider";
import PigFiltersProvider from "./PigFiltersProvider";
import LoadingWrapper from "../LoadingSpinnerWrapper";

export const ACTIVE_URL = "/pig-tracking/active";
export const COMPLETED_URL = "/pig-tracking/history";
export const PIG_ALERTS_URL = "/pig-tracking/pig-alerts";
export const PIG_HISTORY_URL = "/pig-tracking/pig-history";

const PigTracking = () => {
  const { permissions } = useAuth();
  const { pigCount, alertsCount, loading } = usePigHeaderContext();

  // const [currentTab, setCurrentTab] = useState("active");
  const [subTitle, setSubTitle] = useState(`${pigCount.active} active runs`);

  // Old code used to change the sub title of the pig tracking page.
  // Moved the logic into the components being returned below. This is the approach the monitoring page uses.
  // useEffect(() => {
  //   const count =
  //     currentTab === "active" ? pigCount.active : pigCount.completed;
  //   console.log("currentTab", currentTab);
  //   setSubTitle(`${count} ${currentTab} runs`);
  // }, [pigCount, alertsCount, currentTab]);

  // const onActivated = ({ title }: IActivatedCallBack) => {
  //   console.log("onActivated", title);
  //   setCurrentTab(title);
  // };

  const activeTab = {
    url: ACTIVE_URL,
    title: `Active Runs (${pigCount.active})`,
    content: (
      <ActiveRuns
        hideEmptyCta={pigCount.active <= 0 && pigCount.completed <= 0}
        emptyUrl={COMPLETED_URL}
        onActivated={({ title }: IActivatedCallBack) => {
          setSubTitle(`${pigCount.active} ${title} runs`);
        }}
        // onActivated={onActivated}
      />
    )
  };

  const completedTab = {
    url: COMPLETED_URL,
    title: `Completed Runs (${pigCount.completed})`,
    content: (
      <PigFiltersProvider>
        <CompletedRuns
          loading={loading || false}
          empty={pigCount.completed === 0}
          onActivated={({ title }: IActivatedCallBack) => {
            setSubTitle(`${pigCount.completed} ${title} runs`);
          }}
          // onActivated={onActivated}
        />
      </PigFiltersProvider>
    )
  };

  const alertsTab = {
    url: PIG_ALERTS_URL,
    title: `Alert Monitoring (${alertsCount.activeAlerts})`,
    content: (
      <PigAlertsPage
        onActivated={({ title }: IActivatedCallBack) => {
          setSubTitle(`${alertsCount.activeAlerts} ${title} events`);
        }}
        // onActivated={onActivated}
      />
    )
  };

  const historyTab = {
    url: PIG_HISTORY_URL,
    title: `Alert History (${alertsCount.history})`,
    content: (
      <PigHistoryPage
        onActivated={({ title }: IActivatedCallBack) => {
          setSubTitle(`${alertsCount.history} ${title} events`);
        }}
        // onActivated={onActivated}
      />
    )
  };

  const tabs = [activeTab, completedTab, alertsTab, historyTab];

  if (loading) {
    return <LoadingWrapper loading />;
  } else if (permissions.user["pig-tracking"]) {
    return (
      <ScreenLayout title="Pig Tracking" subtitle={subTitle}>
        <MobilePageTitle page="Pig Tracking" subtitle={subTitle} />
        <TabbedContent tabs={tabs} title="Pig Tracking Navigation" />
      </ScreenLayout>
    );
  } else {
    return <Redirect to="/" />;
  }
};

const PigTrackingPage = () => (
  <PigHeaderProvider>
    <PigTracking />
  </PigHeaderProvider>
);

export default PigTrackingPage;
